import HeaderProyecto from "../04-Proyecto/HeaderProyecto";
import CustomStages from "../04-Proyecto/CustomStages";
import CustomHospitalLevels from "../04-Proyecto/CustomHospitalLevels";
import CustomHospitalizationProtocols from "../04-Proyecto/CustomHospitalizationProtocols";
import InfrastructureSection from "../04-Proyecto/InfrastructureSection";
import CustomQuietZones from "../04-Proyecto/CustomQuietZones";
import CustomHospitalAccess from "../04-Proyecto/CustomHospitalAccess";

const ProjectCreation = () => {
  return (
    <>
      <HeaderProyecto />
      <CustomStages />
      <CustomHospitalLevels />
      <CustomHospitalizationProtocols />
      <InfrastructureSection />
      <CustomQuietZones />
      <CustomHospitalAccess/>
    </>
  );
};
export default ProjectCreation;
